import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dialog__header" }

import { useDialogStore } from '@/stores/dialogs';


export default /*#__PURE__*/_defineComponent({
  __name: 'VDialogHeader',
  setup(__props) {

const dialogStore = useDialogStore()


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(_component_v_btn, {
      variant: "flat",
      height: "40",
      width: "40",
      class: "rounded-circle ml-auto",
      icon: "mdi-close",
      onClick: _unref(dialogStore).close
    }, null, 8, ["onClick"])
  ]))
}
}

})